export interface AppDef {
  id: string;
  label: string;
  icon: string;
  group: "Workstation" | "Mission Control";
  pinned?: boolean;
  adminOnly?: boolean;
  /** Set to false to hide from start menu (still accessible via URL) */
  showInStartMenu?: boolean;
  defaultSize?: { width: number; height: number };
  /** Mark as coming soon — grayed out in start menu, not openable */
  comingSoon?: boolean;
}

export const APP_REGISTRY: readonly AppDef[] = [
  // ── Workstation: developer-facing daily-driver apps ──────────
  { id: "home", label: "Home", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M8 12h8 M12 8v8", group: "Workstation", pinned: true },
  { id: "chat", label: "Chat", icon: "M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z", group: "Workstation", pinned: true, defaultSize: { width: 960, height: 640 } },
  { id: "files", label: "opentool_code", icon: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6", group: "Workstation", pinned: true },
  { id: "file-explorer", label: "File Explorer", icon: "M1.5 3v10h13V5H7.5l-1-2H1.5z M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5", group: "Workstation" },
  { id: "canvas", label: "Canvas", icon: "M3 3h18v18H3z M3 9h18 M9 21V9", group: "Workstation", pinned: true },
  { id: "notebook", label: "Notebook", icon: "M4 19.5A2.5 2.5 0 016.5 17H20 M4 19.5V5a2 2 0 012-2h14v14H6.5A2.5 2.5 0 004 19.5z M9 7h6 M9 11h4", group: "Workstation", pinned: true },
  { id: "browser", label: "Browser", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M2 12h20 M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10A15.3 15.3 0 0112 2z", group: "Workstation" },
  { id: "terminal", label: "Console", icon: "M4 5h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2z M6.5 9.5l2 2-2 2 M11 13h5", group: "Workstation", pinned: true, defaultSize: { width: 1040, height: 700 } },
  { id: "taskboard", label: "Task Board", icon: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z", group: "Workstation" },
  { id: "archmap", label: "Arch Map", icon: "M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z", group: "Workstation" },
  { id: "memory", label: "Memory", icon: "M4 4h16v16H4z M4 12h16 M12 4v16 M8 4v8 M16 4v8", group: "Workstation" },
  { id: "scheduler", label: "Scheduler", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M12 6v6l4 2", group: "Workstation" },
  { id: "wallpapers", label: "Wallpapers", icon: "M2 3h20v14H2z M6 21h12 M12 17v4 M2 3l20 14 M22 3L2 17", group: "Workstation" },
  { id: "settings", label: "Settings", icon: "M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z", group: "Workstation" },

  // ── Mission Control: admin/governance tools ──────────────────
  { id: "access", label: "Access Control", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4", group: "Mission Control", pinned: true },
  { id: "cost", label: "Cost Ledger", icon: "M12 1v22 M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6", group: "Mission Control" },
  { id: "autopilot", label: "Autopilot", icon: "M12 2l7 4v6c0 5-3.5 9.74-7 12-3.5-2.26-7-7-7-12V6l7-4z M9 12l2 2 4-4", group: "Mission Control", adminOnly: true, pinned: true, defaultSize: { width: 1180, height: 760 } },
  { id: "arbiter", label: "Arbiter", icon: "M12 2l8 4v6c0 6-4 11-8 14-4-3-8-8-8-14V6l8-4z M8 12h8 M12 8v8", group: "Mission Control", adminOnly: true, pinned: true, defaultSize: { width: 1240, height: 820 } },
  { id: "analyzer", label: "Analyzer", icon: "M4 19h16 M6 16l3-3 3 2 5-6 2 2", group: "Mission Control", pinned: true, defaultSize: { width: 1200, height: 760 } },
  { id: "quarantine", label: "Quarantine", icon: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", group: "Mission Control" },
  { id: "benchmark", label: "Benchmark", icon: "M12 20V10 M18 20V4 M6 20v-4", group: "Mission Control", comingSoon: true },
  { id: "drift", label: "Drift", icon: "M22 12h-4l-3 9L9 3l-3 9H2", group: "Mission Control", comingSoon: true },
  { id: "provenance", label: "Provenance", icon: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22", group: "Mission Control", comingSoon: true },
  { id: "replay", label: "Replay", icon: "M3 12a9 9 0 109-9 M3 3v9h9", group: "Mission Control", comingSoon: true },
  { id: "registry", label: "Registry", icon: "M21 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v3 M3 16v3a2 2 0 002 2h14a2 2 0 002-2v-3 M12 12m-3 0a3 3 0 106 0 3 3 0 00-6 0 M1 12h4 M19 12h4", group: "Mission Control" },
  { id: "admin", label: "Admin", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0h4 M9 12l2 2 4-4", group: "Mission Control", adminOnly: true },

  // ── Hidden: accessible via URL only ──────────────────────────
  { id: "projects", label: "Projects", icon: "M2 3h20v14a2 2 0 01-2 2H4a2 2 0 01-2-2V3z M8 21h8 M12 17v4", group: "Workstation", showInStartMenu: false },
  { id: "recipes", label: "Recipes", icon: "M4 19.5A2.5 2.5 0 016.5 17H20 M4 19.5V5a2 2 0 012-2h14v14H6.5A2.5 2.5 0 004 19.5z", group: "Workstation", showInStartMenu: false },
  { id: "knowledge", label: "Knowledge", icon: "M12 2a10 10 0 100 20 10 10 0 000-20z M12 8v8 M8 12h8", group: "Workstation", showInStartMenu: false },
  { id: "tools", label: "Tools", icon: "M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z", group: "Workstation", showInStartMenu: false },
  { id: "blog", label: "Blog", icon: "M4 19.5A2.5 2.5 0 016.5 17H20 M4 19.5V5a2 2 0 012-2h14v14H6.5A2.5 2.5 0 004 19.5z M8 7h8 M8 11h6", group: "Workstation", showInStartMenu: false },
];

export const ROUTE_LABELS: Record<string, string> = Object.fromEntries(
  APP_REGISTRY.map((a) => [a.id, a.label]),
);

export const GROUP_ORDER = ["Workstation", "Mission Control"] as const;

export const GROUP_COLORS: Record<string, string> = {
  Workstation: "#4f8fff",
  "Mission Control": "#f87171",
};

export const PINNED_APPS = APP_REGISTRY.filter((a) => a.pinned);

export function getAppDef(id: string): AppDef | undefined {
  return APP_REGISTRY.find((a) => a.id === id);
}

// ── Dynamic API-backed registry ──────────────────────────────

/** Raw shape returned by the API (snake_case) */
interface ApiAppEntry {
  id: string;
  label: string;
  icon: string;
  group: string;
  pinned?: boolean;
  admin_only?: boolean;
  show_in_start_menu?: boolean;
  default_size?: { width: number; height: number };
  coming_soon?: boolean;
  component_url?: string;
}

function apiEntryToAppDef(e: ApiAppEntry): AppDef {
  return {
    id: e.id,
    label: e.label,
    icon: e.icon,
    group: e.group as AppDef["group"],
    pinned: e.pinned,
    adminOnly: e.admin_only,
    showInStartMenu: e.show_in_start_menu,
    defaultSize: e.default_size,
    comingSoon: e.coming_soon,
  };
}

/**
 * Fetch the app registry from the backend.
 * Falls back to the hardcoded APP_REGISTRY on failure.
 */
export async function fetchAppRegistry(): Promise<AppDef[]> {
  try {
    const { apiFetch } = await import("./api");
    const res = await apiFetch("/api/apps");
    if (!res.ok) return [...APP_REGISTRY];
    const data = await res.json();
    const apiApps: AppDef[] = (data.apps ?? []).map(apiEntryToAppDef);
    return mergeRegistries(APP_REGISTRY as unknown as AppDef[], apiApps);
  } catch {
    return [...APP_REGISTRY];
  }
}

/**
 * Merge hardcoded and API registries. API entries take precedence for matching IDs.
 * New API-only entries are appended.
 */
function mergeRegistries(base: AppDef[], api: AppDef[]): AppDef[] {
  const apiMap = new Map(api.map((a) => [a.id, a]));
  const merged: AppDef[] = base.map((b) => apiMap.get(b.id) ?? b);
  // Append any API-only apps not in the base
  for (const a of api) {
    if (!base.some((b) => b.id === a.id)) {
      merged.push(a);
    }
  }
  return merged;
}

// ── Reactive global state ────────────────────────────────────

type Listener = () => void;

let _liveRegistry: AppDef[] = [...APP_REGISTRY];
let _listeners: Listener[] = [];
let _fetched = false;

/** Subscribe to registry updates. Returns an unsubscribe function. */
export function subscribeAppRegistry(listener: Listener): () => void {
  _listeners.push(listener);
  return () => {
    _listeners = _listeners.filter((l) => l !== listener);
  };
}

/** Get the current live registry (may include API-loaded apps). */
export function getLiveRegistry(): readonly AppDef[] {
  return _liveRegistry;
}

/** Trigger a fetch and update the live registry. Safe to call multiple times. */
export function refreshAppRegistry(): void {
  if (_fetched) return;
  _fetched = true;
  fetchAppRegistry().then((apps) => {
    _liveRegistry = apps;
    for (const l of _listeners) l();
  });
}

/** Get a live app def by id (checks live registry first, then hardcoded fallback). */
export function getLiveAppDef(id: string): AppDef | undefined {
  return _liveRegistry.find((a) => a.id === id) ?? APP_REGISTRY.find((a) => a.id === id);
}

// ── React hook ───────────────────────────────────────────────

import { useState, useEffect } from "react";

/**
 * React hook that returns the live app registry.
 * Triggers a fetch on first use and re-renders when the registry updates.
 */
export function useAppRegistry(): readonly AppDef[] {
  const [registry, setRegistry] = useState<readonly AppDef[]>(_liveRegistry);

  useEffect(() => {
    const unsub = subscribeAppRegistry(() => {
      setRegistry([..._liveRegistry]);
    });
    refreshAppRegistry();
    return unsub;
  }, []);

  return registry;
}
